import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import SuccessModal from '../../components/Modal/SuccessModal'
import AuthActions from '../../actions/AuthActions'

const Container = styled.main`
  .landing-page {
    display: block;
    width: 100vw;
    height: 100vh;
    background: #2d3030;
    text-align: center;
    position: relative;

    .background {
      position: absolute;
      top: 0px;
      left: 0px;
      opacity: 0.3;
      background: url('../img/Landing/landing.jpg') no-repeat center;
      background-size: cover;
      width: 100vw;
      height: 100vh;

      -webkit-backdrop-filter: blur(2px);
      backdrop-filter: blur(2px);
      filter: blur(2px);
    }
  }
`

class ActivateAccount extends Component {
  render () {
    const { t, router } = this.props
    return (
      <Container>
        <div className='landing-page'>
          <div className='background' />
          <SuccessModal
            header={t('Activate Account')}
            visible
            closeAction={() => {
              AuthActions.logout()
              router.replace('/')
            }}
            message={t(
              'Thank you for completing the preliminary steps.  We will be in touch shortly in order to arrange a personal conversation.'
            )}
          />
        </div>
      </Container>
    )
  }
}

ActivateAccount.propTypes = {
  errorMessage: PropTypes.string,
  user: PropTypes.object,
  t: PropTypes.func,
  router: PropTypes.object
}

export default translate([ 'common', 'landing' ], { wait: true })(
  ActivateAccount
)



// WEBPACK FOOTER //
// ./src/pages/ActivateAccount/index.js